import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import cardData from "@/assets/home/card-data.webp";
import cardMcp from "@/assets/home/card-mcp.webp";
import cardResearch from "@/assets/home/card-research.webp";
import cardStrategy from "@/assets/home/card-strategy.webp";
import { Section, SectionHeader } from "@/components/marketing/Section";
import { StaggeredList } from "@/components/ui/motion";
import { preserveSearch } from "@/lib/nav";
import CategoryCard from "./CategoryCard";

// "What we provide" follows the decision journey: notice, understand, test,
// decide. The glass renders stay conceptual: governed data, research evidence,
// strategy machinery, and the connected portfolio workflow.
const CARD_IMAGES = [cardData, cardResearch, cardStrategy, cardMcp];
const CARD_GUIDES = ["/docs/markets", "/docs/agent", "/docs/backtesting", "/docs/portfolio"];

const Categories = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const cards = t("categories.cards", { returnObjects: true }) as {
    tag: string;
    title: string;
    body: string;
    guide: string;
  }[];

  return (
    <Section id="solutions" viewport>
      <SectionHeader title={t("categories.title")} subtitle={t("categories.subtitle")} />

      <StaggeredList
        className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4"
        staggerDelay={0.12}
      >
        {cards.map((card, index) => (
          <CategoryCard
            key={card.title}
            image={CARD_IMAGES[index] ?? cardData}
            tag={card.tag}
            title={card.title}
            description={card.body}
            href={preserveSearch(CARD_GUIDES[index] ?? "/docs", search)}
            linkLabel={card.guide}
          />
        ))}
      </StaggeredList>
    </Section>
  );
};

export default Categories;
